var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card none-border",staticStyle:{"background":"transparent"}},[_c('div',{staticClass:"card-body"},[_c('img',{staticClass:"mb-3",attrs:{"src":require("@/assets/images/nodata.svg"),"alt":"","width":"100"}}),_c('p',[_vm._v("no data available!")])])])
}]

export { render, staticRenderFns }